import { useEffect, useState } from "react";
import Table from "../../../components/common/table/Table";
import Title from "../../../components/common/title/Title";
import { getApi } from "../../../services/api/globalApi";
import ExportExcel from "../../../components/common/export-exel/ExportExel";
import moment from "jalali-moment";
import { userCustomersReportsColumns } from "../../../constant/tablesColumns/tablesColums";
import { convertDate } from "../../../utils/convertDate";
import UserCustomersReportsFilter from "./userCustomersReportsFilter";

export default function UserCustomers() {
  const [reportsData, setReportsData] = useState([]);

  const getProductReports = async (params) => {
    const path = "admin/reports/allInfoUserCustomersWithOldDataOrder";
    try {
      const response = await getApi({ path, params: { ...params } });
      const result = response?.data?.result || [];
      const convertData = result.map((item) => {
        item.paymentDate = convertDate(item.paymentDate);
        return item;
      });
      setReportsData(convertData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    filterDataHandler({
      from: moment().locale("en").format("YYYY-MM-DD"),
      to: moment().locale("en").format("YYYY-MM-DD"),
    });
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    getProductReports(allFilter);
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex flex-col sm:flex-row justify-betwseen items-center">
        <Title title={"لیست مشتریان کاربران"} />
        <div className="w-full mt-4 sm:mt-0 flex justify-end">
          <ExportExcel jsonData={reportsData || []} />
        </div>
      </div>
      <UserCustomersReportsFilter filterDataHandler={filterDataHandler} />
      <Table columns={userCustomersReportsColumns} rows={reportsData || []} />
    </div>
  );
}
